import { formatContextMoney } from "@/lib/storefront-cart-context";

export type Locale = "en" | "ar" | "fr";
export type Currency = "AED" | "USD" | "SAR";

export const LOCALE_LABEL: Record<Locale, string> = {
  en: "English",
  ar: "العربية",
  fr: "Français",
};

/**
 * اللغات الظاهرة في مبدّل الواجهة. الفرنسيّة مخفيّة حالياً لكنّ
 * البنية التحتيّة (قواميس، أنواع، رسائل واتساب) كاملة — لإعادة تفعيلها
 * أضف "fr" إلى هذه القائمة فقط.
 */
export const VISIBLE_LOCALES: Locale[] = ["en", "ar"];

export const CURRENCY_LABEL: Record<Currency, string> = {
  AED: "AED",
  USD: "USD",
  SAR: "SAR",
};

// Approx conversion rates from store base currency.
// Shopify checkout uses the store's true currency; this is for display only.
export const CURRENCY_RATES: Record<Currency, number> = {
  AED: 1,
  SAR: 1.02,
  USD: 0.27,
};

export const CURRENCY_SYMBOL: Record<Currency, string> = {
  AED: "AED",
  USD: "$",
  SAR: "SAR",
};

type Dict = Record<string, string>;

const en: Dict = {
   "nav.home": "Home",
   "nav.shop": "Shop",
   "nav.gift_box": "Gift Box",
   "nav.for_him": "For Him",
  "nav.all_perfumes": "All Perfume",
  "nav.new_product": "New Product",
  "nav.for_her": "For Her",
  "nav.unisex": "Unisex",
   "nav.gifts": "Gifts",
   "nav.journal": "Journal",
   "nav.about": "About",
   "nav.contact": "Contact",
   "nav.account": "My Account",
  // تسميات قصيرة للناف بار السفليّ (الموبايل) — سطر واحد داخل خليّة ضيّقة
  "nav.bottom_bag": "Bag",
  "nav.bottom_account": "Account",
  "pwa.nudge_title": "Install our app on your phone",
  "pwa.nudge_dismiss": "Dismiss",
  "nav.ambassadors": "Loyalty & Ambassadors",
  "nav.track_order": "Track an order",
  "nav.media_library": "Media library",
  "nav.single_perfume": "Single Perfume",
   "nav.gift_sets": "Gift Sets",
    "nav.lady_bag": "LADY BAG PERFUME",
   "nav.body_care": "Body Care",
  "nav.discovery_kit": "Discovery Kit",
  "nav.attars": "Attars",
  "nav.intense_bakhoor": "Intense / Bakhoor",
  "nav.wedding": "Wedding",
  "nav.oud": "Oud Scent",
  "nav.ambassador_program": "Loyalty & Ambassadors",
  "cta.discover": "Discover Your Scent",
  "cta.gift": "Send as a Gift",
  "cta.gift_oos": "This variant is out of stock",
  "cta.gift_preparing": "Preparing your gift…",
  "cta.gift_ready": "Your gift is ready — fill in the details!",
  "cta.add": "Add to Bag",
  "cta.shop_all": "Shop All Fragrances",
  "cta.shop_all_story": "LECMO — the story of perfume",
  "cta.view_collection": "View this collection",
  "cta.read": "Read the Story",
  "hero.poetry": "Some scents linger longer than memory.",
  "hero.eyebrow": "A Fragrance Story",
  "section.featured": "Featured Fragrances",
  "section.gifts": "Gifts she'll remember",
  "section.gifts_sub": "Curated for the moments that matter most.",
  "section.story": "Our Story",
  "section.story_body":
    "Each bottle is composed like a poem — top notes that whisper, a heart that lingers, and a base that becomes you.",
  "section.editorial": "From the Journal",
  "section.newsletter": "Join the loyalty & ambassador program",
  "section.newsletter_sub":
    "Private launches, scent guides, and quiet rituals — straight to your inbox.",
  "newsletter.placeholder": "Your email",
  "newsletter.subscribe": "Subscribe",
  "newsletter.thanks": "Welcome — check your inbox.",
  "search.placeholder": "Search fragrances, notes, moods…",
  "search.recent": "Recent",
  "search.trending": "Trending",
  "search.browse_by_mood": "Browse by mood",
  "search.no_results": "No fragrances match this search.",
  "search.suggestions": "Did you mean",
  "search.journal": "From the Journal",
  "tag.oriental": "Oriental",
  "tag.feminine": "Feminine",
  "tag.masculine": "Masculine",
  "tag.unisex": "Unisex",
  "tag.floral": "Floral",
  "tag.woody": "Woody",
  "tag.fresh": "Fresh",
  "tag.spicy": "Spicy",
  "tag.sweet": "Sweet",
  "tag.gift": "Gift",
  "tag.daily": "Daily",
  "tag.evening": "Evening",
  "shop.filter.clear": "Clear filters",
  "shop.filter.results": "{count} fragrances",
  "shop.filter.open": "Filter",
  "shop.filter.open_with_count": "Filter · {count}",
  "shop.filter.apply": "View {count} fragrances",
  "shop.filter.title": "Refine the collection",
  "cart.title": "Your Bag",
  "cart.empty": "Your bag is quiet.",
  "cart.empty_sub": "Add a fragrance to begin.",
  "cart.subtotal": "Subtotal",
  "cart.promo_code": "Promo code",
  "cart.promo_apply": "Apply",
  "cart.promo_applied": "Promo applied",
  "cart.promo_placeholder": "Enter code",
  "cart.discount_applied": "Code {code} applied",
  "cart.discount_apply_error": "Could not apply code. Check spelling or restrictions.",
  "cart.discount_no_cart": "Add an item before applying a code.",
  "cart.wallet_prompt": "Have points or wallet balance?",
  "cart.wallet_balance": "Your balance: {amount}",
  "cart.wallet_min_hint": "From {min}",
  "cart.wallet_redeem": "Redeem",
  "wallet.steps.title": "How to pay with your wallet",
  "wallet.steps.trigger_label": "How to use wallet balance",
  "wallet.steps.step1": "Make sure your wallet balance covers the order total.",
  "wallet.steps.step2": "Tap the «Redeem» button next to your wallet balance at the bottom of the cart.",
  "wallet.steps.step3": "The card value is applied automatically at checkout.",
  "wallet.steps.step4": "Complete your order securely.",
  "cart.clear": "Empty bag",
  "cart.clear_confirm_title": "Clear your bag?",
  "cart.clear_confirm_desc": "All items will be removed. This cannot be undone.",
  "cart.clear_confirm_action": "Yes, clear it",
  "cart.checkout": "Secure Checkout",
  "cart.gift_note": "Gift wrapped",
  "cart.recommended": "You may also like",
  "cart.fab_label": "View bag",
  "cart.minimize": "Minimize bag",
  "cart.expand": "Expand bag",
  "cart.close": "Close bag",
  "cart.gift_to": "To {recipient}",
  "cart.gift_when_24h": "Within 24 hours",
  "cart.gift_edit": "Edit gift",
  "cart.gift_internal_note": "Private note for our team",
  "cart.gift_team_will_contact": "Our team will reach out within an hour to confirm the gift details.",
  "cart.gift_no_cod": "Cash on delivery is not available for gifts — prepayment required to protect the surprise.",
  "cart.gift_address_at_checkout": "Recipient's shipping address is collected on the secure checkout page.",
  "cart.checkout_next_step": "Next step: shipping address & payment.",
  "cart.gift_recipient_name_label": "Recipient name",
  "cart.gift_recipient_phone_label": "Recipient phone (optional)",
  "cart.gift_message_label": "Your message (optional)",
  "cart.gift_packaging_label": "Packaging",
  "cart.gift_occasion_label": "Occasion",
  "cart.gift_message_placeholder": "Write your card message here…",
  "cart.gift_advanced_edit": "Advanced options",
  "cart.gift_remove": "Remove gift",
  "cart.move_to_wishlist": "Move to Wishlist",
  "cart.moved_to_wishlist": "Moved to wishlist",
  "cart.wishlist_add": "Save for later",
  "cart.wishlist_saved": "Saved",
  "cart.wishlist_added": "Added to wishlist",
  "cart.wishlist_removed": "Removed from wishlist",
  "cart.view_wishlist": "View",
  "cart.move_failed": "Couldn't move item, try again",
  "cart.remove": "Remove",
  "cart.reminder_phone_label": "Your WhatsApp number",
  "cart.reminder_phone_placeholder": "+971 XX XXX XXXX",
  "cart.reminder_consent": "Remind me on WhatsApp if I forget my cart",
  "cart.reminder_saved": "We'll remind you — promise!",
  "cart.reminder_consent_note": "One message only. Unsubscribe anytime.",
  "cart.add_another_gift": "Send a gift to someone else",
  "cart.add_another_gift_hint": "Pick a product below — each recipient gets their own address",
  "cart.add_another_gift_pick_below": "Pick from below",
  "cart.add_another_gift_browse_shop": "Browse the shop",
  "cart.recommended_hint": "Tap + to add a product to your order.",
  "cart.gift_send_label": "Gift",
  "cart.gift_as_gift": "Send as a gift",
  "cart.convert_to_gift": "Send as a gift",
  "cart.convert_to_gift_hint": "Add a recipient, message and delivery date",
  "cart.gift_save_hint": "Saved automatically",
  "cart.gift_recipient_name_required": "Recipient name is required.",
  "cart.gift_phone_invalid": "Enter a valid mobile number.",
  "cart.gift_section_message": "Card message",
  "cart.gift_section_recipient": "Recipient",
  "cart.gift_section_address": "Delivery address",
  "cart.gift_section_advanced": "More options",
  "cart.gift_address_country": "Country",
  "cart.gift_address_city": "City / Emirate",
  "cart.gift_address_line": "Street & building",
  "cart.gift_address_zip": "Postal code (optional)",
  "cart.gift_address_driver_notes": "Notes for the driver",
  "cart.gift_address_driver_ph": "e.g. Call before arriving · Leave with concierge",
  "cart.gift_address_required": "Complete the recipient's address before checkout",
  "cart.gift_address_prefilled": "The address will be pre-filled on the checkout page",
  "cart.gift_address_city_required": "City is required.",
  "cart.gift_address_line_required": "Address is required.",
  "gift.continue_in_cart": "Continue in cart",
  "gift.address_notice_title": "Recipient's shipping address",
  "gift.address_notice_help": "You'll enter the street, city and postcode in the next step on Shopify's secure checkout — we don't store it here.",
  "product.description": "Description",
  "product.notes": "Scent Notes",
  "product.top": "Top",
  "product.heart": "Heart",
  "product.base": "Base",
  "product.pairs": "Pairs beautifully with",
  "product.discover_this": "Discover this product",
  "product.size": "Size",
  "product.tab.editor": "Editor's advice",
  "product.tab.details": "Key details",
  "product.tab.notes": "Notes",
  "product.tab.delivery": "Delivery & returns",
  "product.tab.reviews": "Reviews",
  "product.read_more": "Read more",
  "product.read_less": "Read less",
  "product.reviews.empty": "No reviews yet — be the first to share your experience.",
  "product.reviews.setup_hint": "Reviews widget is not configured yet.",
  "product.reviews.showMore": "read more reviews",
  "product.reviews.showLess": "read less",
  "product.shipping_from": "Shipping from UAE",
  "product.same_day": "Same-day delivery to {city}",
  "product.need_help": "Need help?",
  "product.call_us": "Call us",
  "product.whatsapp": "WhatsApp",
  "product.whatsapp_inquiry": "Hi! I'd like to ask about *{title}*.\n{url}",
  "product.delivery_body": "Free delivery within the UAE on orders over AED 300. Same-day in Dubai before 6 PM. Returns accepted within 14 days on unopened items.",
  "product.details_brand": "Brand",
  "product.details_type": "Category",
  "product.details_variant": "Variant",
  "gift.title": "Send as a Gift",
  "gift.title_convert": "Make this a gift",
  "gift.step1": "Packaging",
  "gift.step2": "Your message",
  "gift.step3": "Recipient",
  "gift.step4": "Preview",
  "gift.next": "Continue",
  "gift.back": "Back",
  "gift.add": "Add Gift to Bag",
  "gift.add_and_checkout": "Add & Checkout",
  "gift.add_another_product": "Add another product",
  "gift.complete_checkout": "Continue to checkout",
  "gift.save_changes": "Save Changes",
  "gift.toast_added": "Gift prepared for {recipient} ✨ — added to your bag",
  "gift.toast_added_generic": "Gift prepared ✨ — added to your bag",
  "gift.prefilled_from_account": "Recipient «{name}» loaded from your address book",
  "gift.prefill_banner": "We're preparing a gift for {name} — pick a fragrance below.",
  "gift.prefill_banner_dismiss": "Dismiss",
  "gift.message_placeholder": "Write your card message here…",
  "gift.recipient_name": "Recipient name",
  "gift.sender_name": "From",
  "gift.delivery_date": "Preferred delivery date",
  "gift.delivery_promise_title": "Delivered within 24 hours",
  "gift.delivery_promise_help": "Across the UAE — for orders placed before 6 PM.",
  "gift.delivery_pick_date_toggle": "Pick a specific date instead",
  "gift.delivery_pick_date_help": "Choose this only if you'd like the gift to arrive on a particular day.",
  "gift.delivery_pick_date_placeholder": "Select a date",
  "gift.preview_title": "A gift for {recipient}",
  "gift.preview_from": "with love, {sender}",
  "gift.recipient_phone": "Recipient mobile",
  "gift.notify_label": "Notify the recipient automatically",
  "gift.notify_help": "We'll WhatsApp the recipient when the order is on its way and again when it's delivered.",
  "gift.notify_auto_assurance": "We'll notify {recipient} the moment the order ships and again on delivery.",
  "gift.notify_phone_required": "Mobile number is required to send automated notifications.",
  "gift.recipient_required": "Recipient name is required.",
  "gift.message_required": "Please write a short gift message.",
  "gift.fill_required_fields": "Please fill in the recipient name and gift message before continuing.",
  "gift.notify_manual_toggle": "I'd rather send the message myself",
  "gift.notify_card_title": "Manual share (optional)",
  "gift.notify_card_help": "Prefer to send it yourself? Use one of these to deliver the message manually.",
  "gift.notify_share_wa": "Share via WhatsApp",
  "gift.notify_share_email": "Share via email",
  "gift.notify_copy": "Copy message",
  "gift.notify_copied": "Copied",
  "gift.notify_phone_invalid": "Enter a valid mobile number with country code.",
  "gift.notify_no_phone_yet": "Add a mobile number above to generate a WhatsApp link.",
  "gift.cancel": "Cancel",
  "gift.preview_label": "Live preview",
  "gift.preview_product_label": "Product preview",
  "gift.preview_card_label": "Card preview",
  "gift.preview_empty_notice": "Dear customer, you haven't written a card yet — add your words so the recipient feels your personal touch.",
  "gift.preview_to": "To {recipient}",
  "gift.preview_to_placeholder": "To your loved one",
  "gift.preview_from_placeholder": "— with love",
  "gift.section_message": "Card message",
  "gift.section_who": "To & From",
  "gift.section_packaging": "Choose the packaging",
  "gift.section_delivery": "Delivery & notification",
  "gift.occasion_label": "Occasion",
  "gift.occasion_placeholder": "Choose an occasion (optional)",
  "gift.occasion_birthday": "Birthday",
  "gift.occasion_anniversary": "Anniversary",
  "gift.occasion_wedding": "Wedding",
  "gift.occasion_graduation": "Graduation",
  "gift.occasion_thank_you": "Thank you",
  "gift.occasion_congrats": "Congratulations",
  "gift.occasion_just_because": "Just because",
  "gift.no_emoji_notice": "Emoji are not supported on the printed card.",
  "gift.message_url_stripped": "Links aren't allowed in the gift message — we removed them so your WhatsApp share keeps a single product link.",
  "gift.address_optional_placeholder": "Optional — leave blank if you're not sure",
  "gift.address_reassure_title": "Dear customer — don't worry if you don't know the full address.",
  "gift.address_reassure_body": "Just pick the country and our concierge team will reach out to the recipient directly to confirm the exact delivery details.",
  "gift.field_optional": "Optional",
  "gift.field_required": "Required",
  "gift.field_optional_hint": "We can deliver without it.",
  "gift.field_required_country": "We need the country to route your gift.",
  "gift.field_required_phone": "We need the recipient's mobile to coordinate delivery directly with them.",
  "gift.field_required_sender_phone": "We need your mobile to keep you updated about the gift status.",
  "gift.sender_phone": "Your mobile",
  "gift.validation_summary_title": "Just one more step before we can save your gift:",
  "gift.validation_missing_country": "Choose the destination country.",
  "gift.validation_missing_phone": "Add the recipient's mobile so we can reach them for delivery.",
  "gift.validation_invalid_phone": "The recipient's mobile doesn't look right — check the digits.",
  "gift.validation_missing_sender_phone": "Add your mobile so we can keep you updated.",
  "gift.validation_invalid_sender_phone": "Your mobile doesn't look right — check the digits.",
  "gift.section_internal": "Instructions for our team",
  "gift.internal_notes_label": "Tell us how to handle the delivery",
  "gift.internal_notes_placeholder": "e.g. Don't reveal the sender's name · Call after 7 PM before delivering · Leave with the concierge · Wrap in red ribbon",
  "gift.internal_notes_help": "Read by Lecmo staff only — never printed on the card and never shown to the recipient.",
  "footer.tagline": "Composed in the East. Worn everywhere.",
  "footer.shop": "Shop",
  "footer.house": "The House",
  "footer.help": "Help",
  "footer.account_col": "Account",
  "footer.discover": "Discover",
  "footer.legal": "Legal",
  "footer.more": "More",
  "footer.less": "Less",
  "footer.shipping": "Shipping",
  "footer.returns": "Returns",
  "footer.privacy": "Privacy",
  "footer.terms": "Terms",
  "footer.faq": "FAQ",
  "footer.ambassador": "Ambassador Program",
  "footer.my_orders": "My orders",
  "footer.wishlist": "Wishlist",
  "footer.my_account": "My account",
  "footer.whatsapp": "WhatsApp us",
  "footer.admin_login": "Admin login",
  "ambassadors.meta.title": "Ambassador Program — Lecmo",
  "ambassadors.meta.description": "Join the Lecmo Ambassador Program. Share fragrances you love, earn commissions, and grow with us.",
  "ambassadors.hero.eyebrow": "Ambassador Program",
  "ambassadors.hero.title": "Become a Lecmo Ambassador",
  "ambassadors.hero.subtitle": "Three tiers, one program — share what you love and earn from day one.",

  "ambassadors.tiers.intro.title": "Three tiers, one program",
  "ambassadors.tiers.intro.subtitle": "Every account starts as Lecmo Lover automatically — no application, no waiting. Earn from your very first sale and get promoted automatically as you grow.",

  "ambassadors.tiers.lover.name": "Lecmo Lover",
  "ambassadors.tiers.lover.tag": "Starts automatically with any account",
  "ambassadors.tiers.lover.short": "Your starting point. No application needed — your account is ready the moment you sign up.",
  "ambassadors.tiers.lover.details": "• A personal code and trackable link the moment you sign up.\n• Cash commission on every confirmed sale.\n• Withdraw to bank or use as Lecmo credit.\n• Auto-promotion to Lecmo Ambassador as your sales and audience grow — no extra application.",

  "ambassadors.tiers.ambassador.name": "Lecmo Ambassador",
  "ambassadors.tiers.ambassador.tag": "Automatic promotion as you grow",
  "ambassadors.tiers.ambassador.short": "The natural next step. Reached automatically as your activity grows.",
  "ambassadors.tiers.ambassador.details": "• Higher commission rate on every sale.\n• Priority on new fragrance samples.\n• Featured spots in our content rotation.\n• Promotion is automatic — keep sharing and the system upgrades you.",

  "ambassadors.tiers.superstar.name": "Super Star Ambassador",
  "ambassadors.tiers.superstar.tag": "By application & review",
  "ambassadors.tiers.superstar.short": "Our top tier. Reserved for trusted voices with real influence — assigned only after we review your application.",
  "ambassadors.tiers.superstar.details": "• Premium commission rate and personal Lecmo credit.\n• Curated gift boxes and exclusive launches.\n• Direct line with our team.\n• Granted only after we review your audience and content — submit the form below to apply.",

  "ambassadors.tiers.lover.encourage": "Start today and watch the flow of profits in your account and the growth of your followers.",
  "ambassadors.tiers.ambassador.encourage": "Keep sharing and watch your status rise — automatically.",
  "ambassadors.tiers.superstar.encourage": "If your voice has real reach, this tier was built for you.",

  "ambassadors.tiers.read_more_about": "Read more about {name}",
  "ambassadors.tier_page.back": "Back to all tiers",
  "ambassadors.tier_page.benefits_title": "What you get in this tier",
  "ambassadors.tier_page.cta_lover": "Create your Lecmo Parfums account",
  "ambassadors.tier_page.cta_ambassador": "Open my ambassador dashboard",
  "ambassadors.tier_page.cta_superstar": "Apply for Super Star review",
  "ambassadors.tier_page.encourage_member": "You're already a Lecmo ambassador — your link is ready to share. Drop it in your stories or WhatsApp and start earning commission today.",
  "ambassadors.tier_page.cta_share_link": "Grow your reach & earnings in one tap",


  "ambassadors.cta.start_lover_title": "Start now — your account is your ambassador account",
  "ambassadors.cta.start_lover_desc": "Create your Lecmo account and you become a Lecmo Lover instantly. Earn from your first sale and get auto-promoted as you grow.",
  "ambassadors.cta.start_lover_button": "Create account",
  "ambassadors.cta.open_dashboard_button": "Open my ambassador dashboard",
  "ambassadors.cta.member_title": "You're already a Lecmo ambassador",
  "ambassadors.cta.member_desc": "Your link is ready — share it on stories and WhatsApp and start earning commission now.",

  "ambassadors.cta.apply_superstar_title": "Want to apply directly as Super Star Ambassador?",
  "ambassadors.cta.apply_superstar_desc": "Super Star is the only tier that requires manual review. Fill in the form below and our team will get back to you within 48 hours.",
  "ambassadors.cta.apply_superstar_button": "Apply for Super Star review",
  "ambassadors.cta.hide_form": "Hide the application form",
  "ambassadors.benefits.title": "What you get",
  "ambassadors.benefits.commission.title": "Commission on every sale",
  "ambassadors.benefits.commission.body": "Cash credits in AED on every purchase made through your link or code.",
  "ambassadors.benefits.code.title": "Your own code & link",
  "ambassadors.benefits.code.body": "A unique code your audience can use, with a trackable short link.",
  "ambassadors.benefits.samples.title": "Sample priority",
  "ambassadors.benefits.samples.body": "Early access to new fragrances and exclusive sample boxes.",
  "ambassadors.flow.title": "How it works",
  "ambassadors.flow.step1": "Fill the form below (40 seconds).",
  "ambassadors.flow.step2": "We auto-create your account if you don't have one — a magic link arrives in your inbox.",
  "ambassadors.flow.step3": "Our team reviews your audience within 48 hours.",
  "ambassadors.flow.step4": "Once approved, you're promoted to Ambassador with full benefits.",
  "ambassadors.whatsapp.title": "Have questions? Talk to us on WhatsApp",
  "ambassadors.whatsapp.body": "Quick answers about the program, your application status, or commission details.",
  "ambassadors.whatsapp.cta": "Chat on WhatsApp",
  "ambassadors.whatsapp.prefill": "Hi Lecmo team, I'm interested in the Ambassador Program and have a question.",
  "ambassadors.form.title": "Apply now",
  "ambassadors.form.email": "Email",
  "ambassadors.form.email_placeholder": "you@example.com",
  "ambassadors.form.name": "Your name",
  "ambassadors.form.name_placeholder": "Sara",
  "ambassadors.form.whatsapp": "Phone",
  "ambassadors.form.whatsapp_placeholder": "501234567",
  "ambassadors.form.dial_code": "Country code",
  "ambassadors.form.phone_required": "Phone number is required",
  "ambassadors.form.phone_invalid": "Phone number doesn't match the selected country code",
  "ambassadors.form.platform": "Platform",
  "ambassadors.form.handle": "Username",
  "ambassadors.form.handle_placeholder": "@yourhandle",
  "ambassadors.form.profile_url": "Profile URL (optional)",
  "ambassadors.form.profile_url_placeholder": "@yourhandle or https://instagram.com/yourhandle",
  "ambassadors.form.profile_url_hint": "You can type just your username — we'll turn it into a full link.",
  "ambassadors.form.login_required_title": "Sign in first",
  "ambassadors.form.login_required_desc": "Applying for Super Star requires a Lecmo account, so we can link the application to you and follow up.",
  "ambassadors.form.login_required_button": "Sign in / Create account",
  "ambassadors.form.insights": "Insights screenshot (optional)",
  "ambassadors.form.insights_hint": "Upload a screenshot of your followers/views (PNG, JPG, PDF — max 5MB)",
  "ambassadors.form.insights_uploading": "Uploading…",
  "ambassadors.form.insights_uploaded": "Uploaded",
  "ambassadors.form.insights_error": "Upload failed. Try again.",
  "ambassadors.form.insights_remove": "Remove file",
  "ambassadors.form.followers": "Followers",
  "ambassadors.form.country": "Country",
  "ambassadors.form.country_placeholder": "Select your country",
  "ambassadors.form.pitch": "Tell us about yourself (optional)",
  "ambassadors.form.pitch_placeholder": "What kind of content do you create? Why fragrances?",
  "ambassadors.form.pitch_count": "{count}/500",
  "ambassadors.form.submit": "Submit application",
  "ambassadors.form.submitting": "Submitting…",
  "ambassadors.form.success_new_account": "Application received. Check your inbox — we sent you a magic link to activate your account.",
  "ambassadors.form.success_existing": "Application received. We'll review and notify you within 48 hours.",
  "ambassadors.form.error_rate": "Too many submissions. Please try again in a few minutes.",
  "ambassadors.form.error_generic": "Something went wrong. Please try again or contact us on WhatsApp.",
  "ambassadors.form.name_required": "Your name is required",
  "ambassadors.form.reference_label": "Your application ID",
  "ambassadors.form.reference_copied": "Copied",
  "ambassadors.form.reference_hint": "Keep it for reference if you contact us",
  "ambassadors.platforms.instagram": "Instagram",
  "ambassadors.platforms.tiktok": "TikTok",
  "ambassadors.platforms.youtube": "YouTube",
  "ambassadors.platforms.snapchat": "Snapchat",
  "ambassadors.platforms.twitter": "X / Twitter",
  "ambassadors.platforms.other": "Other",
  "ambassadors.form.accounts_title": "Your social accounts",
  "ambassadors.form.account_n": "Account #{n}",
  "ambassadors.form.add_account": "Add another account",
  "ambassadors.form.remove_account": "Remove",
  "ambassadors.form.main_badge": "Main platform",
  "ambassadors.form.make_main": "Make main",
  "ambassadors.form.profile_preview": "Preview profile",
  "ambassadors.form.content_category": "Content category",
  "ambassadors.form.content_category_placeholder": "Select your content category",
  "ambassadors.form.category.fashion_beauty": "Fashion & Beauty",
  "ambassadors.form.category.food_cuisine": "Food & Cuisine",
  "ambassadors.form.category.travel_tourism": "Travel & Tourism",
  "ambassadors.form.category.technology": "Technology",
  "ambassadors.form.category.sports_fitness": "Sports & Fitness",
  "ambassadors.form.category.lifestyle": "Lifestyle",
  "ambassadors.form.category.education": "Education & Development",
  "ambassadors.form.category.games": "Games",
  "ambassadors.form.category.music_art": "Music & Art",
  "ambassadors.form.category.business_finance": "Business & Finance",
  "ambassadors.form.category.other": "Other",

  "admin.applications.title": "Ambassador applications",
  "admin.applications.empty": "No applications yet.",
  "admin.applications.status.pending": "Pending",
  "admin.applications.status.approved": "Approved",
  "admin.applications.status.rejected": "Rejected",
  "admin.applications.approve": "Approve",
  "admin.applications.reject": "Reject",
  "admin.applications.note_placeholder": "Optional admin note",
  "admin.applications.confirm_approve": "Approve this application and promote to Ambassador?",
  "admin.applications.confirm_reject": "Reject this application?",
  "admin.applications.request_info": "Request more info",
  "admin.applications.confirm_request_info": "Request more info from the applicant? Add what you need in the note field — it will be sent to them via WhatsApp and email.",
  "admin.applications.status.needs_info": "Info requested",
  "admin.applications.request_info_hint": "Type what you need in the note above first, then click.",
  "shop.title": "The Collection",
  "shop.subtitle": "All fragrances, composed with patience.",
  "shop.filter.family": "Family",
  "shop.filter.mood": "Mood",
  "shop.filter.occasion": "Occasion",
  "shop.empty": "No products found",
  "shop.empty_sub": "Tell us what fragrance you'd like to add.",
  "shop.collections.label": "Browse by collection",
  "shop.collections.all": "All",
  "shop.tabs.count": "{n} products",

  "shop.section.all": "All fragrances",
  "shop.section.him": "For Him",
  "shop.section.her": "For Her",
  "shop.section.unisex": "Unisex",
  "shop.section.gifts": "Gift Boxes",
  "shop.section.empty": "Coming soon",
  "shop.divider.eyebrow": "The House of Lecmo",
  "shop.divider.line": "Patience · Precision · Provenance",
  "quickview.view_full": "View full details",
  "quickview.close": "Close",
  "common.from": "From",
  "common.loading": "Loading…",
  "common.remove": "Remove",
  "wa.message": "Hi, I'd like help choosing a fragrance.",
  "account.orders.title": "My orders",
  "account.orders.subtitle": "Your recent purchases — synced from our store.",
  "account.orders.empty": "No orders yet.",
  "account.orders.empty_sub": "When you place your first order, it will appear here.",
  "account.orders.shop_cta": "Browse the collection",
  "account.orders.items_count": "{count} item(s)",
  "account.orders.placed_on": "Placed on {date}",
  "account.orders.track_shipment": "Track shipment",
  "account.orders.no_tracking": "Tracking will appear once shipped.",
  "account.orders.error": "Couldn't load your orders. Please try again later.",
  "account.orders.no_email_match": "No orders found for this email. Use the same email at checkout to see your purchases here.",
  "account.orders.fulfillment.fulfilled": "Delivered",
  "account.orders.fulfillment.partial": "Partially shipped",
  "account.orders.fulfillment.unfulfilled": "Processing",
  "account.orders.fulfillment.shipped": "Shipped",
  "account.orders.financial.paid": "Paid",
  "account.orders.financial.pending": "Pending",
  "account.orders.financial.refunded": "Refunded",
  "account.orders.financial.partially_refunded": "Partially refunded",
  "account.orders.financial.authorized": "Authorized",
  "account.orders.financial.voided": "Voided",
  "account.card.orders": "My orders",
  "account.card.orders_sub": "View purchase history",
  "account.card.recipients": "Address book",
  "account.card.recipients_sub": "{count} saved",
  "account.card.profile": "My address",
  "account.card.profile_sub": "Used for gifts to yourself",
  "account.recipients.title": "Saved recipients",
  "account.recipients.subtitle": "Names, phone numbers and addresses you've used for past gifts.",
  "account.recipients.empty": "No saved recipients yet.",
  "account.recipients.empty_sub": "Send a gift and we'll save the recipient here for next time.",
  "account.recipients.delete": "Delete",
  "account.recipients.delete_confirm": "Remove this recipient from your address book?",
  "account.recipients.deleted": "Recipient removed.",
  "account.profile.title": "My personal address",
  "account.profile.subtitle": "Used when you choose «Gift to myself» — saves you from typing it again.",
  "account.profile.display_name": "Display name",
  "account.profile.phone": "Mobile (E.164, e.g. +9715xxxxxxxx)",
  "account.profile.country": "Country (ISO-2)",
  "account.profile.city": "City",
  "account.profile.address": "Street & building",
  "account.profile.driver_notes": "Notes for the driver",
  "account.profile.save": "Save changes",
  "account.profile.saved": "Saved.",
  "gift.signin_invite": "Sign in to save recipients and reuse them next time.",
  "gift.signin_cta": "Sign in",
  "gift.address_book_title": "Choose a recipient",
  "gift.address_book_question": "Who is this gift for?",
  "gift.mode_self": "Gift to myself",
  "gift.mode_self_ready": "Use my saved address",
  "gift.mode_self_first": "First time — we'll save it",
  "gift.mode_saved_pick": "Pick a saved recipient",
  "gift.mode_saved_empty": "No saved recipients yet",
  "gift.mode_new": "New recipient",
  "gift.mode_new_hint": "We'll save it for next time",

  // ─── Markets / ROW / Gift override ───
  "row.not_serving_country":
    "Sorry — we don't ship to your country yet.",
  "row.not_serving_country_long":
    "We currently ship only to Saudi Arabia, UAE, Iraq and Oman. Reach out and we'll do our best to help.",
  "row.contact_whatsapp": "Contact us on WhatsApp",
  "row.gift_alternative":
    "You can still send a perfume as a gift to loved ones in the Gulf.",
  "row.shop_disabled_badge": "Shipping unavailable",
  "row.price_approx_notice":
    "Approximate price · final amount charged in USD via WhatsApp order.",
  "gift.market_switch_title": "Pricing will switch markets",
  "gift.market_switch_body":
    "You're sending to {country}. Prices will switch to the {country} market ({currency}) for the rest of this gift session. Continue?",
  "gift.sender_phone_country": "Sender phone country",
  "gift.destination_unavailable_short": "not available yet",
  "gift.destination_unavailable": "Gift delivery to this country isn't available yet. Please choose another country.",
  "gift.market_switch_unavailable": "Some items aren't available in the recipient's country: {items}. Your bag was not changed.",
  "gift.market_switch_failed": "We couldn't switch your bag's pricing. Your bag was not changed; please try again.",
  "gift.save_failed": "We couldn't save the gift details. Nothing was lost; please try again.",
  "gift.market_switch_uncertain": "We couldn't confirm your bag's country and prices. Checkout is paused until we re-check your bag.",
  "gift.remove_failed": "We couldn't remove the gift details. The gift is still on your bag; please try again.",
  "gift.reprice_failed": "This item isn't available at a confirmed price in the recipient's country. Nothing was added.",
  "cart.market_uncertain": "Your bag needs a quick re-check before checkout.",
  "cart.market_recheck": "Re-check my bag",
  "cart.market_recheck_failed": "We still couldn't confirm your bag. You can try again or empty the bag and start over.",
  "cart.checkout_changed": "Your bag changed while preparing checkout. Please try again.",
  "gift.checkout_not_ready": "Gift details aren't saved yet. Please review the gift and try again.",
  "gift.delivery_timing_title": "Delivery timing",
  "gift.delivery_timing_help": "Delivery time and options for this country are shown at checkout.",
  "gift.market_switch_continue": "Continue",
  "gift.market_switch_cancel": "Cancel",
  "gift.recipient_market_unsupported":
    "Gifts can currently be sent to the UAE, Saudi Arabia, Qatar, Oman, Iraq and the United States.",
  "gift.payment_card_currency_notice":
    "You'll be charged in your card's currency — your bank converts automatically.",
  "gift.active_indicator": "Bag priced for {country}",
  "gift.cancel_override": "Return bag to my country's prices",
  "market.switcher_locked_cart": "Prices locked for checkout",
  "market.switcher_gift_active": "Bag priced for {country}",
  "cart.market_mismatch":
    "Your bag is locked to {current}. Each market has its own prices, shipping, and currency, so a single bag can't mix them. Clear the bag to switch to {target}, or use ✨ Send as gift to ship one item to another country.",
  "cart.market_switch_title": "Switch market and clear your bag?",
  "cart.market_switch_body":
    "Your bag is currently priced for {current} ({currentCurrency}). Prices and shipping for {target} ({targetCurrency}) are different, so we can't mix them in one order.",
  "cart.market_switch_keep": "Keep my bag",
  "cart.market_switch_clear": "Clear bag & switch to {target}",
  "cart.market_switch_hint":
    "Tip: to send a gift to another country without changing your own market, use ✨ Send as gift on any product.",
  // ── Cart services (Tabby + Loyalty) ──
  "cart.service.tabby_title": "Pay in 4 with Tabby",
  "cart.service.tabby_badge": "At checkout",
  "cart.service.tabby_body":
    "Split your order into 4 interest-free payments of about {amount} via Tabby. The Tabby option appears on the secure checkout page when available in your country (UAE & KSA).",
  "cart.service.loyalty_title": "Lecmo Loyalty",
  "cart.service.loyalty_badge": "Coming soon",
  "cart.service.loyalty_body":
    "Earn points on every order and unlock exclusive previews, samples, and private events. Launching soon.",
  "product.tabby_banner": "Or 4 payments of {amount} — interest-free with Tabby or Tamara.",
  // ── Full cart page (/cart) ──
  "cart.page_title": "My Bag",
  "cart.continue_shopping": "Continue shopping",
  "cart.summary_title": "Order summary",
  "cart.shipping_label": "Shipping",
  "cart.shipping_calculated": "Calculated at checkout",
  "cart.shipping_free": "Free",
  "cart.grand_total": "Grand total",
  "cart.vat_inclusive": "VAT inclusive",
  "cart.payment_methods_title": "Payment methods accepted",
  "cart.help_title": "Need help?",
  "cart.help_call": "Call us",
  "cart.help_whatsapp": "WhatsApp",
};

const ar: Dict = {
   "nav.home": "الرئيسية",
   "nav.shop": "المتجر",
   "nav.gift_box": "علبة هدايا",
  "nav.for_him": "للرجال",
  "nav.all_perfumes": "كل العطور",
  "nav.new_product": "احدث المنتجات",
  "nav.for_her": "للنساء",
  "nav.unisex": "للجنسين",
   "nav.gifts": "الهدايا",
   "nav.journal": "اليوميات",
   "nav.about": "عنّا",
   "nav.contact": "تواصل",
   "nav.account": "حسابي",
  "nav.bottom_bag": "السلة",
  "nav.bottom_account": "حسابي",
  "pwa.nudge_title": "ثبّت تطبيقنا على هاتفك",
  "pwa.nudge_dismiss": "إغلاق",
  "nav.ambassadors": "برنامج الولاء والسفراء",
  "nav.track_order": "تتبّع طلبك",
  "nav.media_library": "مكتبة الصور والفيديوهات للنشر",
  "nav.single_perfume": "عطر فردي",
   "nav.gift_sets": "أطقم الهدايا",
   "nav.lady_bag": "حقيبة العطور للسيدات",
  "nav.body_care": "العناية بالجسم",
  "nav.discovery_kit": "طقم الاكتشاف",
  "nav.attars": "العطور الزيتية",
  "nav.intense_bakhoor": "المكثّف / البخور",
  "nav.wedding": "الأعراس",
  "nav.oud": "عطور العود",
  "nav.ambassador_program": "برنامج الولاء والسفراء",
  "cta.discover": "اكتشف عطرك",
  "cta.gift": "أرسلها هدية",
  "cta.gift_oos": "هذه النسخة غير متوفرة حالياً",
  "cta.gift_preparing": "جاري تجهيز هديّتك…",
  "cta.gift_ready": "هديّتك جاهزة — أكمل التفاصيل!",
  "cta.add": "أضف إلى الحقيبة",
  "cta.shop_all": "تسوق كل العطور",
  "cta.shop_all_story": "LECMO — حكاية عطر",
  "cta.view_collection": "استعرض هذه المجموعة",
  "cta.read": "اقرأ الحكاية",
  "hero.poetry": "عطورٌ تبقى أطول من الذاكرة.",
  "hero.eyebrow": "حكاية عطرية",
  "section.featured": "عطور مختارة",
  "section.gifts": "هدايا لا تُنسى",
  "section.gifts_sub": "اختيارات للحظات التي تستحق.",
  "section.story": "حكايتنا",
  "section.story_body":
    "كل قارورة تُؤلَّف كقصيدة — مقدمة همسٌ، وقلبٌ يبقى، وقاعدةٌ تصبح أنت.",
  "section.editorial": "من اليوميات",
  "section.newsletter": "انضمّ إلى برنامج الولاء والسفراء",
  "section.newsletter_sub": "إصدارات خاصة وأدلة عطور — مباشرة إلى بريدك.",
  "newsletter.placeholder": "بريدك الإلكتروني",
  "newsletter.subscribe": "اشترك",
  "newsletter.thanks": "مرحباً بك — تفقّد بريدك.",
  "search.placeholder": "ابحث عن عطر، نوتة، مزاج…",
  "search.recent": "الأخيرة",
  "search.trending": "الأكثر بحثاً",
  "search.browse_by_mood": "تصفّح حسب المزاج",
  "search.no_results": "لا توجد نتائج مطابقة.",
  "search.suggestions": "هل تقصد",
  "search.journal": "من اليوميّات",
  "tag.oriental": "شرقي",
  "tag.feminine": "حريمي / نسائي",
  "tag.masculine": "رجالي",
  "tag.unisex": "للجنسين",
  "tag.floral": "زهري",
  "tag.woody": "خشبي",
  "tag.fresh": "منعش",
  "tag.spicy": "حار / توابل",
  "tag.sweet": "حلو",
  "tag.gift": "هدية",
  "tag.daily": "يومي",
  "tag.evening": "سهرة",
  "shop.filter.clear": "مسح الفلاتر",
  "shop.filter.results": "{count} عطر",
  "shop.filter.open": "فلترة",
  "shop.filter.open_with_count": "فلترة · {count}",
  "shop.filter.apply": "عرض {count} عطر",
  "shop.filter.title": "نقّ المجموعة",
  "cart.title": "حقيبتك",
  "cart.empty": "حقيبتك هادئة.",
  "cart.empty_sub": "أضف عطراً لتبدأ.",
  "cart.subtotal": "المجموع الكلي",
  "cart.promo_code": "كود الخصم",
  "cart.promo_apply": "تطبيق",
  "cart.promo_applied": "تمّ تطبيق الكود",
  "cart.promo_placeholder": "أدخل الكود",
  "cart.discount_applied": "تمّ تطبيق {code}",
  "cart.discount_apply_error": "تعذّر تطبيق الكود. تأكّد منه أو من شروطه.",
  "cart.discount_no_cart": "أضف منتجاً قبل تطبيق كود الخصم.",
  "cart.wallet_prompt": "لديك نقاط أو رصيد محفظة؟",
  "cart.wallet_balance": "رصيدك: {amount}",
  "cart.wallet_min_hint": "ادفع عبر رصيد محفظتك",
  "cart.wallet_redeem": "استبدال",
  "wallet.steps.title": "كيف تدفع برصيد محفظتك؟",
  "wallet.steps.trigger_label": "كيفية استخدام رصيد المحفظة",
  "wallet.steps.step1": "تأكّد أن رصيد محفظتك يغطّي إجمالي الطلب.",
  "wallet.steps.step2": "اضغط زرّ «استبدال» بجانب رصيد المحفظة في أسفل السلة.",
  "wallet.steps.step3": "تُطبَّق قيمة البطاقة تلقائياً عند الدفع.",
  "wallet.steps.step4": "أكمل طلبك بأمان.",
  "cart.clear": "تفريغ السلة",
  "cart.clear_confirm_title": "تفريغ السلة؟",
  "cart.clear_confirm_desc": "سيُحذف كلّ ما في السلة. لا يمكن التراجع عن هذه الخطوة.",
  "cart.clear_confirm_action": "نعم، فرّغها",
  "cart.checkout": "إتمام الشراء",
  "cart.gift_note": "مغلَّف كهدية",
  "cart.recommended": "قد يعجبك أيضاً",
  "cart.fab_label": "عرض الحقيبة",
  "cart.minimize": "تصغير الحقيبة",
  "cart.expand": "توسيع الحقيبة",
  "cart.close": "إغلاق الحقيبة",
  "cart.gift_to": "إلى {recipient}",
  "cart.gift_when_24h": "خلال ٢٤ ساعة",
  "cart.gift_edit": "تعديل الهديّة",
  "cart.gift_internal_note": "ملاحظة خاصّة لفريقنا",
  "cart.gift_team_will_contact": "سيتواصل معك فريق Lecmo خلال ساعة لتأكيد تفاصيل الهديّة.",
  "cart.gift_no_cod": "الدفع عند الاستلام غير متاح للهدايا — الدفع المسبق إلزامي حفاظاً على المفاجأة.",
  "cart.gift_address_at_checkout": "سيُطلب عنوان شحن المُهدى إليه في صفحة الدفع الآمنة.",
  "cart.checkout_next_step": "الخطوة التالية: عنوان الشحن والدفع.",
  "cart.gift_recipient_name_label": "اسم المُهدى إليه",
  "cart.gift_recipient_phone_label": "هاتفه (اختياري)",
  "cart.gift_message_label": "رسالتك (اختياري)",
  "cart.gift_packaging_label": "التغليف",
  "cart.gift_occasion_label": "المناسبة",
  "cart.gift_message_placeholder": "اكتب رسالة الكرت هنا…",
  "cart.gift_advanced_edit": "خيارات متقدّمة",
  "cart.gift_remove": "إزالة الهديّة",
  "cart.move_to_wishlist": "نقل إلى المفضّلة",
  "cart.moved_to_wishlist": "تمّ النقل إلى المفضّلة",
  "cart.wishlist_add": "احفظ للاحقاً",
  "cart.wishlist_saved": "في المفضّلة",
  "cart.wishlist_added": "أُضيف إلى المفضّلة",
  "cart.wishlist_removed": "أُزيل من المفضّلة",
  "cart.view_wishlist": "عرض",
  "cart.move_failed": "تعذّر النقل، حاول مجدّداً",
  "cart.remove": "حذف",
  "cart.reminder_phone_label": "رقم واتسابك",
  "cart.reminder_phone_placeholder": "+٩٧١ XX XXX XXXX",
  "cart.reminder_consent": "ذكّرني على واتساب إذا نسيت سلّتي",
  "cart.reminder_saved": "سنُذكّرك — وعد!",
  "cart.reminder_consent_note": "رسالة واحدة فقط. يمكنك إلغاء الاشتراك في أيّ وقت.",
  "cart.add_another_gift": "أرسل هديّة لشخص آخر",
  "cart.add_another_gift_hint": "اختر منتجاً من الأسفل — لكلّ مُهدى إليه عنوانه الخاصّ",
  "cart.add_another_gift_pick_below": "اختر من التوصيات",
  "cart.add_another_gift_browse_shop": "تصفّح كل المتجر",
  "cart.recommended_hint": "اضغط + لإضافة المنتج إلى طلبك.",
  "cart.gift_send_label": "هديّة",
  "cart.gift_as_gift": "أرسلها كهديّة",
  "cart.convert_to_gift": "إرسال كهديّة",
  "cart.convert_to_gift_hint": "أضف المُهدى إليه ورسالةً وتاريخ التوصيل",
  "cart.gift_save_hint": "تُحفظ تلقائياً",
  "cart.gift_recipient_name_required": "اسم المُهدى إليه إلزامي.",
  "cart.gift_phone_invalid": "أدخل رقم موبايل صحيحاً.",
  "cart.gift_section_message": "رسالة الكرت",
  "cart.gift_section_recipient": "المستلم",
  "cart.gift_section_address": "عنوان التوصيل",
  "cart.gift_section_advanced": "خيارات إضافيّة",
  "cart.gift_address_country": "الدولة",
  "cart.gift_address_city": "المدينة / الإمارة",
  "cart.gift_address_line": "الشارع والمبنى",
  "cart.gift_address_zip": "الرمز البريدي (اختياري)",
  "cart.gift_address_driver_notes": "ملاحظات للسائق",
  "cart.gift_address_driver_ph": "مثال: اتّصل قبل الوصول · سلِّمها للبوّاب",
  "cart.gift_address_required": "أكمل بيانات عنوان المُهدى إليه قبل الدفع",
  "cart.gift_address_prefilled": "سيظهر العنوان مُعبّأً مسبقاً في صفحة الدفع",
  "cart.gift_address_city_required": "المدينة إلزاميّة.",
  "cart.gift_address_line_required": "العنوان التفصيلي إلزامي.",
  "gift.continue_in_cart": "تابع في السلة",
  "gift.address_notice_title": "عنوان شحن المُهدى إليه",
  "gift.address_notice_help": "ستُدخل الشارع والمدينة والرمز البريدي في الخطوة التالية على صفحة Shopify الآمنة — نحن لا نحفظه هنا.",
  "product.description": "الوصف",
  "product.notes": "نوتات العطر",
  "product.top": "المقدمة",
  "product.heart": "القلب",
  "product.base": "القاعدة",
  "product.pairs": "ينسجم بأناقة مع",
  "product.discover_this": "اكتشف هذا المنتج",
  "product.size": "الحجم",
  "product.tab.editor": "نصيحة المحرّر",
  "product.tab.details": "التفاصيل الأساسيّة",
  "product.tab.notes": "النوتات",
  "product.tab.delivery": "التوصيل والإرجاع",
  "product.tab.reviews": "التقييمات",
  "product.read_more": "اقرأ المزيد",
  "product.read_less": "اقرأ أقل",
  "product.reviews.empty": "لا توجد تقييمات بعد — كن أوّل من يشارك تجربته.",
  "product.reviews.setup_hint": "لم يُضبَط نظام التقييمات بعد.",
  "product.reviews.showMore": "read more تعليقات",
  "product.reviews.showLess": "read less",
  "product.shipping_from": "الشحن من الإمارات",
  "product.same_day": "توصيل في نفس اليوم إلى {city}",
  "product.need_help": "بحاجة لمساعدة؟",
  "product.call_us": "اتصل بنا",
  "product.whatsapp": "واتساب",
  "product.whatsapp_inquiry": "مرحباً! أودّ الاستفسار عن عطر *{title}*.\n{url}",
  "product.delivery_body": "توصيل مجّاني داخل الإمارات على الطلبات فوق 300 درهم. توصيل في نفس اليوم في دبي قبل السادسة مساءً. الإرجاع مقبول خلال 14 يوماً للمنتجات غير المفتوحة.",
  "product.details_brand": "العلامة",
  "product.details_type": "الفئة",
  "product.details_variant": "الخيار",
  "gift.title": "أرسلها هدية",
  "gift.title_convert": "تحويل المنتج إلى هديّة",
  "gift.step1": "التغليف",
  "gift.step2": "رسالتك",
  "gift.step3": "المُهدى إليه",
  "gift.step4": "المعاينة",
  "gift.next": "متابعة",
  "gift.back": "رجوع",
  "gift.add": "أضف الهدية إلى الحقيبة",
  "gift.add_and_checkout": "إضافة وإتمام الدفع",
  "gift.add_another_product": "أضف منتجًا آخر",
  "gift.complete_checkout": "أكمل إجراءات الدفع",
  "gift.save_changes": "حفظ التعديلات",
  "gift.toast_added": "جُهِّزت هديّتك لـ {recipient} ✨ — أُضيفت إلى الحقيبة",
  "gift.toast_added_generic": "جُهِّزت هديّتك ✨ — أُضيفت إلى الحقيبة",
  "gift.prefilled_from_account": "تمّ تحميل المستلم «{name}» من دفتر العناوين",
  "gift.prefill_banner": "نُحضّر هديّة لـ {name} — اختر عطراً من الأسفل.",
  "gift.prefill_banner_dismiss": "إغلاق",
  "gift.message_placeholder": "اكتب رسالة الكرت هنا…",
  "gift.recipient_name": "اسم المُهدى إليه",
  "gift.sender_name": "من",
  "gift.delivery_date": "تاريخ التسليم المفضّل",
  "gift.delivery_promise_title": "التسليم خلال ٢٤ ساعة",
  "gift.delivery_promise_help": "داخل الإمارات — للطلبات قبل ٦ مساءً.",
  "gift.delivery_pick_date_toggle": "أو اختر تاريخاً محدّداً",
  "gift.delivery_pick_date_help": "اختر هذا فقط إن أردت وصول الهديّة في يومٍ بعينه.",
  "gift.delivery_pick_date_placeholder": "اختر تاريخاً",
  "gift.preview_title": "هدية إلى {recipient}",
  "gift.preview_from": "بكل حب، {sender}",
  "gift.recipient_phone": "موبايل المُهدى إليه",
  "gift.notify_label": "أبلِغ المُهدى إليه تلقائياً",
  "gift.notify_help": "سنُرسل له رسالة واتساب فور شحن الطلب، ورسالة أخرى عند التسليم.",
  "gift.notify_auto_assurance": "سنُشعر {recipient} تلقائياً فور شحن الطلب وعند التسليم.",
  "gift.notify_phone_required": "رقم الموبايل إلزامي لإرسال الإشعارات التلقائيّة.",
  "gift.recipient_required": "اسم المُهدى إليه إلزامي.",
  "gift.message_required": "اكتب رسالة قصيرة للهديّة.",
  "gift.fill_required_fields": "يرجى إدخال اسم المُهدى إليه ورسالة الهديّة قبل المتابعة.",
  "gift.notify_manual_toggle": "أفضّل الإرسال بنفسي",
  "gift.notify_card_title": "مشاركة يدويّة (اختياري)",
  "gift.notify_card_help": "تُفضّل أن ترسل بنفسك؟ استخدم أحد الخيارات أدناه.",
  "gift.notify_share_wa": "مشاركة عبر واتساب",
  "gift.notify_share_email": "مشاركة عبر البريد",
  "gift.notify_copy": "نسخ الرسالة",
  "gift.notify_copied": "تمّ النسخ",
  "gift.notify_phone_invalid": "أدخل رقم موبايل صحيحاً مع رمز الدولة.",
  "gift.notify_no_phone_yet": "أضف رقم موبايل أعلاه لتوليد رابط واتساب.",
  "gift.cancel": "إلغاء",
  "gift.preview_label": "المعاينة المباشرة",
  "gift.preview_product_label": "معاينة المنتج",
  "gift.preview_card_label": "معاينة الكرت",
  "gift.preview_empty_notice": "عزيزي العميل، لم تكتب بطاقة بعد — اكتب كلماتك ليرى المستلم لمستك الخاصّة.",
  "gift.preview_to": "إلى {recipient}",
  "gift.preview_to_placeholder": "إلى من تحبّ",
  "gift.preview_from_placeholder": "— بكلّ حبّ",
  "gift.section_message": "رسالة الكرت",
  "gift.section_who": "إلى ومن",
  "gift.section_packaging": "اختر التغليف",
  "gift.section_delivery": "التسليم والإشعار",
  "gift.occasion_label": "المناسبة",
  "gift.occasion_placeholder": "اختر المناسبة (اختياري)",
  "gift.occasion_birthday": "عيد ميلاد",
  "gift.occasion_anniversary": "ذكرى سنوية",
  "gift.occasion_wedding": "زواج",
  "gift.occasion_graduation": "تخرّج",
  "gift.occasion_thank_you": "شكر وامتنان",
  "gift.occasion_congrats": "تهنئة",
  "gift.occasion_just_because": "بدون مناسبة",
  "gift.no_emoji_notice": "لا تُطبع الإيموجي على الكرت.",
  "gift.message_url_stripped": "لا يُسمح بإدراج روابط داخل رسالة الهديّة — أزلناها تلقائياً ليبقى رابط واحد فقط في مشاركة واتساب.",
  "gift.address_optional_placeholder": "اختياري — اتركه فارغاً إن لم تكن متأكّداً",
  "gift.address_reassure_title": "عزيزي العميل — لا يهمّك إن لم تعرف العنوان كاملاً، نحن نتكفّل بذلك.",
  "gift.address_reassure_body": "يكفي اختيار الدولة فقط، وسيتواصل فريقنا مع المُهدى إليه مباشرةً لتأكيد تفاصيل التوصيل.",
  "gift.field_optional": "اختياري",
  "gift.field_required": "مطلوب",
  "gift.field_optional_hint": "يمكننا التوصيل من دونه.",
  "gift.field_required_country": "نحتاج الدولة لتوجيه هديّتك.",
  "gift.field_required_phone": "نحتاج رقم المُهدى إليه للتنسيق مباشرةً معه على التوصيل.",
  "gift.field_required_sender_phone": "نحتاج رقمك لإبقائك على اطّلاع بحالة الهديّة.",
  "gift.sender_phone": "رقم موبايلك",
  "gift.validation_summary_title": "خطوة أخيرة قبل أن نحفظ هديّتك:",
  "gift.validation_missing_country": "اختر دولة التسليم.",
  "gift.validation_missing_phone": "أضف موبايل المُهدى إليه لنتواصل معه عند التوصيل.",
  "gift.validation_invalid_phone": "رقم المُهدى إليه لا يبدو صحيحاً — راجع الأرقام.",
  "gift.validation_missing_sender_phone": "أضف رقمك لنُبقيك على اطّلاع.",
  "gift.validation_invalid_sender_phone": "رقمك لا يبدو صحيحاً — راجع الأرقام.",
  "gift.section_internal": "تعليمات لفريقنا",
  "gift.internal_notes_label": "أخبرنا كيف نتعامل مع التسليم",
  "gift.internal_notes_placeholder": "مثلاً: لا تذكروا اسم المُرسل · اتّصلوا بعد الساعة ٧ مساءً قبل التسليم · سلّموها للبوّاب · لِفّوها بشريط أحمر",
  "gift.internal_notes_help": "يطّلع عليها فريق Lecmo فقط — لا تُطبع على البطاقة ولا تُعرض على المُهدى إليه.",
  "footer.tagline": "صُنعت في الشرق. لتقدم في كل مكان.",
  "footer.shop": "المتجر",
  "footer.house": "البيت",
  "footer.help": "المساعدة",
  "footer.account_col": "الحساب",
  "footer.discover": "اكتشف",
  "footer.legal": "القانونيّ",
  "footer.more": "المزيد",
  "footer.less": "إخفاء",
  "footer.shipping": "الشحن",
  "footer.returns": "الإرجاع",
  "footer.privacy": "الخصوصيّة",
  "footer.terms": "الشروط",
  "footer.faq": "الأسئلة الشائعة",
  
  "footer.ambassador": "برنامج السفراء",
  "footer.my_orders": "طلباتي",
  "footer.wishlist": "المفضّلة",
  "footer.my_account": "حسابي",
  "footer.whatsapp": "راسلنا واتساب",
  "footer.admin_login": "دخول لوحة التحكم",
  "ambassadors.meta.title": "برنامج السفراء — Lecmo",
  "ambassadors.meta.description": "انضمّ لبرنامج سفراء Lecmo. شارك العطور التي تحبّها، اكسب عمولات، وانمُ معنا.",
  "ambassadors.hero.eyebrow": "برنامج السفراء",
  "ambassadors.hero.title": "كن سفيراً لـLecmo",
   "ambassadors.hero.subtitle": "ثلاث شرائح، برنامج واحد — شارك ما تحبّ واربح من أوّل يوم.",

   "ambassadors.tiers.intro.title": "ثلاث شرائح في برنامج واحد",
   "ambassadors.tiers.intro.subtitle": "كلّ حساب جديد يبدأ مباشرة كـLecmo Lover — بدون تقديم طلب وبدون انتظار. تربح من أوّل عمليّة بيع وتترقّى تلقائياً كلّما نمت.",

   "ambassadors.tiers.lover.name": "Lecmo Lover",
   "ambassadors.tiers.lover.tag": "يبدأ تلقائياً مع أيّ حساب",
   "ambassadors.tiers.lover.short": "نقطة البداية. لا يحتاج طلباً — حسابك جاهز لحظة تسجيلك.",
   "ambassadors.tiers.lover.details": "• كود خاصّ بك ورابط قابل للتتبّع فور إنشاء الحساب.\n• عمولة نقديّة على كلّ عمليّة بيع مؤكَّدة.\n• السحب على البنك أو استخدامها كرصيد Lecmo.\n• ترقية تلقائيّة إلى Lecmo Ambassador كلّما نمت مبيعاتك وجمهورك — بدون طلب إضافيّ.",

   "ambassadors.tiers.ambassador.name": "Lecmo Ambassador",
   "ambassadors.tiers.ambassador.tag": "ترقية تلقائيّة كلّما نمت",
   "ambassadors.tiers.ambassador.short": "الخطوة الطبيعيّة التالية. تصل إليها تلقائياً مع نشاطك.",
   "ambassadors.tiers.ambassador.details": "• نسبة عمولة أعلى على كلّ عمليّة بيع.\n• أولويّة في عيّنات العطور الجديدة.\n• مساحات مميّزة في دوران المحتوى لدينا.\n• الترقية آليّة بالكامل — استمرّ في المشاركة والنظام يرفعك.",

   "ambassadors.tiers.superstar.name": "Super Star Ambassador",
   "ambassadors.tiers.superstar.tag": "بالتقديم والمراجعة فقط",
   "ambassadors.tiers.superstar.short": "أعلى شريحة لدينا. مخصّصة لأصوات نثق بها وتمتلك تأثيراً حقيقيّاً — تُمنح فقط بعد مراجعة طلبك.",
   "ambassadors.tiers.superstar.details": "• نسبة عمولة مميّزة ورصيد Lecmo شخصيّ.\n• علب هدايا منتقاة وإطلاقات حصريّة.\n• تواصل مباشر مع فريقنا.\n• تُمنح فقط بعد مراجعتنا لجمهورك ومحتواك — أرسل النموذج أدناه للتقديم.",

   "ambassadors.tiers.lover.encourage": "ابدأ اليوم وراقب تدفق الارباح في حسابك ونمو متابعينك.",
   "ambassadors.tiers.ambassador.encourage": "تابع المشاركة وستراقب شريحتك ترتفع تلقائياً.",
   "ambassadors.tiers.superstar.encourage": "إن كان صوتك يصل إلى جمهور حقيقيّ، فهذه الشريحة صُمِّمت لك.",

   "ambassadors.tiers.read_more_about": "اقرأ المزيد عن {name}",
   "ambassadors.tier_page.back": "العودة إلى شرائح السفراء",
   "ambassadors.tier_page.benefits_title": "ما الذي تحصل عليه في هذه الشريحة",
   "ambassadors.tier_page.cta_lover": "أنشئ حسابك في Lecmo Parfums",
   "ambassadors.tier_page.cta_ambassador": "افتح لوحة السفير الخاصّة بي",
   "ambassadors.tier_page.cta_superstar": "تقدّم لمراجعة Super Star",
   "ambassadors.tier_page.encourage_member": "أنت سفير Lecmo بالفعل — رابطك جاهز للمشاركة. ضعه في قصصك أو على واتساب وابدأ في كسب العمولة من اليوم.",
   "ambassadors.tier_page.cta_share_link": "كبّر مساهمتك وأرباحك بكبسة زرّ",


   "ambassadors.cta.start_lover_title": "ابدأ الآن — حسابك هو حسابك كسفير",
   "ambassadors.cta.start_lover_desc": "أنشئ حسابك في Lecmo وتصبح Lecmo Lover فوراً. تربح من أوّل عمليّة بيع وتترقّى تلقائياً كلّما نمت.",
   "ambassadors.cta.start_lover_button": "أنشئ حساب",
   "ambassadors.cta.open_dashboard_button": "افتح لوحة السفير الخاصّة بي",
   "ambassadors.cta.member_title": "أنت سفير Lecmo بالفعل",
   "ambassadors.cta.member_desc": "رابطك جاهز — شاركه في قصصك وواتساب وابدأ في كسب العمولة الآن.",

   "ambassadors.cta.apply_superstar_title": "تريد التقدّم مباشرة كـSuper Star Ambassador؟",
   "ambassadors.cta.apply_superstar_desc": "Super Star هي الشريحة الوحيدة التي تتطلّب مراجعة يدويّة. عبّئ النموذج أدناه ويتواصل فريقنا معك خلال ٤٨ ساعة.",
   "ambassadors.cta.apply_superstar_button": "تقدّم لمراجعة Super Star",
   "ambassadors.cta.hide_form": "إخفاء نموذج التقديم",
  "ambassadors.benefits.title": "ما الذي ستحصل عليه",
  "ambassadors.benefits.commission.title": "عمولة على كل عمليّة بيع",
  "ambassadors.benefits.commission.body": "رصيد نقديّ بالدرهم على كل عمليّة شراء تتمّ عبر رابطك أو كودك.",
  "ambassadors.benefits.code.title": "كودك ورابطك الخاصّان",
  "ambassadors.benefits.code.body": "كود فريد يستخدمه جمهورك، مع رابط قصير قابل للتتبّع.",
  "ambassadors.benefits.samples.title": "أولويّة العيّنات",
  "ambassadors.benefits.samples.body": "وصول مبكّر للعطور الجديدة وعلب عيّنات حصريّة.",
  "ambassadors.flow.title": "كيف تعمل",
  "ambassadors.flow.step1": "املأ النموذج أدناه (٤٠ ثانية).",
  "ambassadors.flow.step2": "نُنشئ لك حساباً تلقائياً إن لم يكن لديك — رابط دخول يصلك على الإيميل.",
  "ambassadors.flow.step3": "فريقنا يراجع جمهورك خلال ٤٨ ساعة.",
  "ambassadors.flow.step4": "عند الموافقة، تُرقَّى لسفير مع كامل المزايا.",
  "ambassadors.whatsapp.title": "عندك سؤال؟ راسلنا على واتساب",
  "ambassadors.whatsapp.body": "إجابات سريعة عن البرنامج، حالة طلبك، أو تفاصيل العمولة.",
  "ambassadors.whatsapp.cta": "محادثة عبر واتساب",
  "ambassadors.whatsapp.prefill": "مرحباً فريق Lecmo، أنا مهتمّ ببرنامج السفراء ولديّ سؤال.",
  "ambassadors.form.title": "قدّم طلبك الآن",
  "ambassadors.form.email": "البريد الإلكترونيّ",
  "ambassadors.form.email_placeholder": "you@example.com",
  "ambassadors.form.name": "اسمك",
  "ambassadors.form.name_placeholder": "سارة",
  "ambassadors.form.whatsapp": "رقم الهاتف",
  "ambassadors.form.whatsapp_placeholder": "501234567",
  "ambassadors.form.dial_code": "رمز الدولة",
  "ambassadors.form.phone_required": "رقم الهاتف مطلوب",
  "ambassadors.form.phone_invalid": "رقم الهاتف غير صالح لكود الدولة المختار",
  "ambassadors.form.platform": "المنصّة",
  "ambassadors.form.handle": "اسم المستخدم",
  "ambassadors.form.handle_placeholder": "@yourhandle",
  "ambassadors.form.profile_url": "رابط الحساب (اختياريّ)",
  "ambassadors.form.profile_url_placeholder": "@yourhandle أو https://instagram.com/yourhandle",
  "ambassadors.form.profile_url_hint": "اكتب اسم المستخدم فقط وسنحوّله لرابط كامل آلياً.",
  "ambassadors.form.login_required_title": "سجّل الدخول أوّلاً",
  "ambassadors.form.login_required_desc": "التقدّم لـSuper Star يتطلّب حساباً في ليكمو، لنربط الطلب بك ونتابعه معك.",
  "ambassadors.form.login_required_button": "تسجيل الدخول / إنشاء حساب",
  "ambassadors.form.insights": "لقطة الإنسايت (اختياريّ)",
  "ambassadors.form.insights_hint": "ارفع لقطة من تحليلات حسابك (PNG/JPG/PDF — حدّ ٥ ميغا)",
  "ambassadors.form.insights_uploading": "جارٍ الرفع…",
  "ambassadors.form.insights_uploaded": "تمّ الرفع",
  "ambassadors.form.insights_error": "فشل الرفع. حاول مجدّداً.",
  "ambassadors.form.insights_remove": "حذف الملفّ",
  "ambassadors.form.followers": "عدد المتابعين",
  "ambassadors.form.country": "الدولة",
  "ambassadors.form.country_placeholder": "اختر دولتك",
  "ambassadors.form.pitch": "عرّفنا بنفسك (اختياريّ)",
  "ambassadors.form.pitch_placeholder": "ما نوع المحتوى الذي تصنعه؟ لماذا العطور؟",
  "ambassadors.form.pitch_count": "{count}/500",
  "ambassadors.form.submit": "إرسال الطلب",
  "ambassadors.form.submitting": "جارٍ الإرسال…",
  "ambassadors.form.success_new_account": "تمّ استلام طلبك. تحقّق من بريدك — أرسلنا لك رابط دخول لتفعيل حسابك.",
  "ambassadors.form.success_existing": "تمّ استلام طلبك. سنراجعه ونعلمك خلال ٤٨ ساعة.",
  "ambassadors.form.error_rate": "محاولات كثيرة جداً. حاول بعد بضع دقائق.",
  "ambassadors.form.error_generic": "حدث خطأ. حاول مجدّداً أو راسلنا على واتساب.",
  "ambassadors.form.name_required": "الاسم مطلوب",
  "ambassadors.form.reference_label": "رقم طلبك",
  "ambassadors.form.reference_copied": "تمّ النسخ",
  "ambassadors.form.reference_hint": "احتفظ به للرجوع إن راسلتنا",
  "ambassadors.platforms.instagram": "إنستغرام",
  "ambassadors.platforms.tiktok": "تيك توك",
  "ambassadors.platforms.youtube": "يوتيوب",
  "ambassadors.platforms.snapchat": "سناب شات",
  "ambassadors.platforms.twitter": "X / تويتر",
  "ambassadors.platforms.other": "أخرى",
  "ambassadors.form.accounts_title": "حساباتك على منصّات التواصل",
  "ambassadors.form.account_n": "الحساب #{n}",
  "ambassadors.form.add_account": "أضف حساباً آخر",
  "ambassadors.form.remove_account": "حذف",
  "ambassadors.form.main_badge": "المنصّة الرئيسيّة",
  "ambassadors.form.make_main": "اجعله الرئيسيّ",
  "ambassadors.form.profile_preview": "معاينة الحساب",
  "ambassadors.form.content_category": "تصنيف المحتوى",
  "ambassadors.form.content_category_placeholder": "اختر تصنيف محتواك",
  "ambassadors.form.category.fashion_beauty": "موضة وجمال",
  "ambassadors.form.category.food_cuisine": "طعام ومطبخ",
  "ambassadors.form.category.travel_tourism": "سفر وسياحة",
  "ambassadors.form.category.technology": "تقنية",
  "ambassadors.form.category.sports_fitness": "رياضة ولياقة",
  "ambassadors.form.category.lifestyle": "أسلوب حياة",
  "ambassadors.form.category.education": "تعليم وتطوير",
  "ambassadors.form.category.games": "ألعاب",
  "ambassadors.form.category.music_art": "موسيقى وفنّ",
  "ambassadors.form.category.business_finance": "أعمال ومال",
  "ambassadors.form.category.other": "أخرى",

  "admin.applications.title": "طلبات السفراء",
  "admin.applications.empty": "لا توجد طلبات بعد.",
  "admin.applications.status.pending": "قيد المراجعة",
  "admin.applications.status.approved": "مقبول",
  "admin.applications.status.rejected": "مرفوض",
  "admin.applications.approve": "موافقة",
  "admin.applications.reject": "رفض",
  "admin.applications.note_placeholder": "ملاحظة للأدمن (اختياريّ)",
  "admin.applications.confirm_approve": "هل تعتمد هذا الطلب وترقّيه لسفير؟",
   "admin.applications.confirm_reject": "هل ترفض هذا الطلب؟",
   "admin.applications.request_info": "اطلب معلومات إضافيّة",
   "admin.applications.confirm_request_info": "هل ترسل للمتقدّم طلب معلومات إضافيّة؟ اكتب المطلوب في خانة الملاحظة أولاً — سيصله عبر واتساب والبريد.",
   "admin.applications.status.needs_info": "تنتظر معلومات",
   "admin.applications.request_info_hint": "اكتب المطلوب في خانة الملاحظة أعلاه أولاً ثمّ اضغط.",
  "shop.title": "المجموعة",
  "shop.subtitle": "كل العطور، مُؤلَّفة بصبر.",
  "shop.filter.family": "العائلة",
  "shop.filter.mood": "المزاج",
  "shop.filter.occasion": "المناسبة",
  "shop.empty": "لا توجد منتجات",
  "shop.empty_sub": "أخبرنا عن العطر الذي تودّ إضافته.",
  "shop.collections.label": "تصفّح حسب المجموعة",
  "shop.collections.all": "الكل",
  "shop.tabs.count": "{n} منتجاً",

  "shop.section.all": "كل العطور",
  "shop.section.him": "للرجال",
  "shop.section.her": "للنساء",
  "shop.section.unisex": "للجنسين",
  "shop.section.gifts": "علب الإهداء",
  "shop.section.empty": "قريباً",
  "shop.divider.eyebrow": "Lecmo Perfume",
  "shop.divider.line": "صبرٌ · دقّةٌ · أصالة",
  "quickview.view_full": "عرض التفاصيل الكاملة",
  "quickview.close": "إغلاق",
  "common.from": "من",
  "common.loading": "جارٍ التحميل…",
  "common.remove": "إزالة",
  "wa.message": "مرحباً، أودّ المساعدة في اختيار عطر.",
  "account.orders.title": "طلباتي",
  "account.orders.subtitle": "آخر مشترياتك — مزامنة من متجرنا.",
  "account.orders.empty": "لا توجد طلبات بعد.",
  "account.orders.empty_sub": "عند إتمامك أوّل طلب، سيظهر هنا تلقائياً.",
  "account.orders.shop_cta": "تصفّح المجموعة",
  "account.orders.items_count": "{count} قطعة",
  "account.orders.placed_on": "بتاريخ {date}",
  "account.orders.track_shipment": "تتبّع الشحنة",
  "account.orders.no_tracking": "سيظهر التتبّع فور الشحن.",
  "account.orders.error": "تعذّر جلب طلباتك. حاول لاحقاً.",
  "account.orders.no_email_match": "لا توجد طلبات بهذا البريد. استخدم نفس البريد عند الدفع لرؤية مشترياتك هنا.",
  "account.orders.fulfillment.fulfilled": "تمّ التسليم",
  "account.orders.fulfillment.partial": "شحن جزئي",
  "account.orders.fulfillment.unfulfilled": "تحت التجهيز",
  "account.orders.fulfillment.shipped": "تمّ الشحن",
  "account.orders.financial.paid": "مدفوع",
  "account.orders.financial.pending": "قيد الدفع",
  "account.orders.financial.refunded": "مسترَد",
  "account.orders.financial.partially_refunded": "مسترَد جزئياً",
  "account.orders.financial.authorized": "مُعتمَد",
  "account.orders.financial.voided": "مُلغى",
  "account.card.orders": "طلباتي",
  "account.card.orders_sub": "عرض سجلّ المشتريات",
  "account.card.recipients": "دفتر المستلمين",
  "account.card.recipients_sub": "{count} محفوظ",
  "account.card.profile": "عنواني الشخصي",
  "account.card.profile_sub": "يُستخدم في «هدية لنفسي»",
  "account.recipients.title": "المستلمون المحفوظون",
  "account.recipients.subtitle": "الأسماء والهواتف والعناوين التي استخدمتها سابقاً في هداياك.",
  "account.recipients.empty": "لا يوجد مستلمون محفوظون بعد.",
  "account.recipients.empty_sub": "أرسل هديّة وسنحفظ المستلم هنا للمرّة القادمة.",
  "account.recipients.delete": "حذف",
  "account.recipients.delete_confirm": "هل تودّ حذف هذا المستلم من دفترك؟",
  "account.recipients.deleted": "تمّ حذف المستلم.",
  "account.profile.title": "عنواني الشخصي",
  "account.profile.subtitle": "يُستخدم عند اختيار «هديّة لنفسي» — كي لا تُعيد كتابته كلّ مرّة.",
  "account.profile.display_name": "الاسم الظاهر",
  "account.profile.phone": "الموبايل (E.164، مثلاً +9715xxxxxxxx)",
  "account.profile.country": "الدولة (ISO-2)",
  "account.profile.city": "المدينة",
  "account.profile.address": "الشارع والمبنى",
  "account.profile.driver_notes": "ملاحظات للسائق",
  "account.profile.save": "حفظ التغييرات",
  "account.profile.saved": "تمّ الحفظ.",
  "gift.signin_invite": "سجّل الدخول لحفظ المستلمين وإعادة استخدامهم لاحقاً.",
  "gift.signin_cta": "تسجيل الدخول",
  "gift.address_book_title": "اختر المستلم",
  "gift.address_book_question": "لمن هذه الهديّة؟",
  "gift.mode_self": "هديّة لنفسي",
  "gift.mode_self_ready": "استخدم عنواني المحفوظ",
  "gift.mode_self_first": "أوّل مرّة — سنحفظه لك",
  "gift.mode_saved_pick": "اختر من المحفوظين",
  "gift.mode_saved_empty": "لا يوجد مستلمون محفوظون",
  "gift.mode_new": "مستلم جديد",
  "gift.mode_new_hint": "سنحفظه للمرّة القادمة",

  // ─── Markets / ROW / Gift override ───
  "row.not_serving_country":
    "للأسف لا نخدم بلدك العزيز حالياً.",
  "row.not_serving_country_long":
    "نشحن حالياً إلى السعودية والإمارات والعراق وعُمان فقط. تواصل معنا وسنبذل جهدنا لمساعدتك.",
  "row.contact_whatsapp": "تواصل عبر واتساب",
  "row.gift_alternative":
    "يمكنك إهداء عطر لأحبّائك في الخليج.",
  "row.shop_disabled_badge": "الشحن غير متاح",
  "row.price_approx_notice":
    "سعر تقريبيّ · المبلغ النهائيّ بالدولار عند تأكيد الطلب عبر واتساب.",
  "gift.market_switch_title": "ستتحوّل الأسعار إلى سوق المستلم",
  "gift.market_switch_body":
    "أنت ترسل إلى {country}. ستتحوّل الأسعار إلى سوق {country} ({currency}) طوال جلسة الإهداء. متابعة؟",
  "gift.sender_phone_country": "دولة رقم المُرسل",
  "gift.destination_unavailable_short": "غير متاح بعد",
  "gift.destination_unavailable": "الإهداء إلى هذه الدولة غير متاح بعد. اختر دولة أخرى.",
  "gift.market_switch_unavailable": "بعض المنتجات غير متوفّرة في دولة المستلم: {items}. لم تتغيّر سلّتك.",
  "gift.market_switch_failed": "تعذّر تبديل تسعير السلّة. لم تتغيّر سلّتك، حاول مجدّداً.",
  "gift.save_failed": "تعذّر حفظ بيانات الهديّة. لم يضع شيء، حاول مجدّداً.",
  "gift.market_switch_uncertain": "تعذّر تأكيد دولة سلّتك وأسعارها. الدفع موقوف حتى نعيد فحص السلّة.",
  "gift.remove_failed": "تعذّرت إزالة بيانات الهديّة. ما زالت الهديّة على سلّتك، حاول مجدّداً.",
  "gift.reprice_failed": "هذا المنتج غير متوفّر بسعر مؤكَّد في دولة المستلم. لم يُضَف شيء.",
  "cart.market_uncertain": "سلّتك تحتاج إعادة فحص سريعة قبل الدفع.",
  "cart.market_recheck": "أعد فحص سلّتي",
  "cart.market_recheck_failed": "ما زال تأكيد السلّة متعذّراً. حاول مجدّداً أو أفرغ السلّة وابدأ من جديد.",
  "cart.checkout_changed": "تغيّرت سلّتك أثناء تجهيز الدفع. حاول مجدّداً.",
  "gift.checkout_not_ready": "بيانات الهديّة لم تُحفظ بعد. راجعها وحاول مجدّداً.",
  "gift.delivery_timing_title": "موعد التوصيل",
  "gift.delivery_timing_help": "مدّة التوصيل وخياراته لهذه الدولة تظهر في صفحة الدفع.",
  "gift.market_switch_continue": "متابعة",
  "gift.market_switch_cancel": "إلغاء",
  "gift.recipient_market_unsupported":
    "يمكن الإهداء حالياً إلى الإمارات والسعودية وقطر وعُمان والعراق والولايات المتحدة.",
  "gift.payment_card_currency_notice":
    "سيتمّ الخصم بعملة بطاقتك — يحوّلها بنكك تلقائياً.",
  "gift.active_indicator": "السلّة بأسعار {country}",
  "gift.cancel_override": "إرجاع السلّة لأسعار بلدي",
  "market.switcher_locked_cart": "الأسعار مُثبَّتة لإتمام الطلب",
  "market.switcher_gift_active": "السلّة بأسعار {country}",
  "cart.market_mismatch":
    "سلّتك مرتبطة حالياً بسوق {current}. لكلّ سوق أسعاره وشحنه وعملته الخاصّة، لذا لا يمكن خلطهما في سلّة واحدة. أفرغ السلّة للتبديل إلى {target}، أو استخدم ✨ إرسال كهديّة لشحن منتج واحد إلى بلد آخر.",
  "cart.market_switch_title": "تبديل السوق وإفراغ السلّة؟",
  "cart.market_switch_body":
    "سلّتك مُسعَّرة الآن بسوق {current} ({currentCurrency}). أسعار وشحن {target} ({targetCurrency}) مختلفة، ولا يمكن جمعهما في طلب واحد.",
  "cart.market_switch_keep": "احتفظ بسلّتي",
  "cart.market_switch_clear": "أفرغ السلّة وبدّل إلى {target}",
  "cart.market_switch_hint":
    "نصيحة: لإرسال هديّة إلى بلد آخر دون تغيير سوقك، استخدم زرّ ✨ إرسال كهديّة على أيّ منتج.",
  // ── Cart services (Tabby + Loyalty) ──
  "cart.service.tabby_title": "ادفع على ٤ دفعات مع Tabby",
  "cart.service.tabby_badge": "عند الدفع",
  "cart.service.tabby_body":
    "قسّم طلبك إلى ٤ دفعات بدون فوائد، كلّ دفعة ≈ {amount} عبر Tabby. يظهر خيار Tabby في صفحة الدفع الآمنة عند توفّره في بلدك (الإمارات والسعوديّة).",
  "cart.service.loyalty_title": "برنامج Lecmo للولاء",
  "cart.service.loyalty_badge": "قريباً",
  "cart.service.loyalty_body":
    "اكسب نقاطاً مع كلّ طلب وافتح أبواب عيّنات حصريّة وعروض مسبقة وحفلات خاصّة. سيُطلق قريباً.",
  "product.tabby_banner": "أو ٤ دفعات بقيمة {amount} — بدون فوائد عبر Tabby أو Tamara.",
  // ── Full cart page (/cart) ──
  "cart.page_title": "حقيبتي",
  "cart.continue_shopping": "متابعة التسوّق",
  "cart.summary_title": "ملخّص الطلب",
  "cart.shipping_label": "الشحن",
  "cart.shipping_calculated": "يُحتسب عند الدفع",
  "cart.shipping_free": "مجّاني",
  "cart.grand_total": "الإجمالي",
  "cart.vat_inclusive": "شامل الضريبة",
  "cart.payment_methods_title": "وسائل الدفع المقبولة",
  "cart.help_title": "تحتاج مساعدة؟",
  "cart.help_call": "اتّصل بنا",
  "cart.help_whatsapp": "واتساب",
};


// نصوص الصفحات التحريريّة (about/journal/contact/gifts/legal/home meta)
// تعيش في ملفّ منفصل لإبقاء هذا الملفّ مركّزاً على نصوص الواجهة.
// تعديل أيّ نصّ مرئيّ ثابت = سطر واحد بثلاث لغات في i18n.content.ts.
import { CONTENT_DICTS } from "@/lib/i18n.content";

export const DICTS: Record<Locale, Dict> = {
  en: { ...en, ...CONTENT_DICTS.en },
  ar: { ...ar, ...CONTENT_DICTS.ar },
  // الفرنسيّة أُرشِفت في i18n.fr.archive.ts (غير محزَّمة للزائر).
  fr: { ...en, ...CONTENT_DICTS.en },
};

/**
 * يدمج قاموساً جزئيّاً (مثل نصوص /admin المفصولة) فوق DICTS وقت التشغيل.
 * يُستدعى من side-effect import داخل حزمة الأدمن فقط.
 */
export function registerDictPart(part: { en?: Dict; ar?: Dict }) {
  if (part.en) {
    Object.assign(DICTS.en, part.en);
    Object.assign(DICTS.fr, part.en);
  }
  if (part.ar) Object.assign(DICTS.ar, part.ar);
}

// ─── تحميل نصوص اللغة عند الحاجة ───
// النصوص التحريريّة العربيّة (~150KB) خارج الحزمة الأساسيّة. أوّل رسم دائماً
// إنجليزيّ (LocaleContext يبدأ بـ"en" على السيرفر والعميل)، فلا وميض ولا
// عدم تطابق hydration. تُطلب قبل تبديل الواجهة إلى العربيّة.
const localeContentLoaded: Partial<Record<Locale, boolean>> = { en: true, fr: true };
const localeContentPending: Partial<Record<Locale, Promise<void>>> = {};

export function isLocaleContentReady(locale: Locale): boolean {
  return localeContentLoaded[locale] === true;
}

export function loadLocaleContent(locale: Locale): Promise<void> {
  if (localeContentLoaded[locale]) return Promise.resolve();
  const pending = localeContentPending[locale];
  if (pending) return pending;
  if (locale !== "ar") {
    localeContentLoaded[locale] = true;
    return Promise.resolve();
  }
  const task = import("@/lib/i18n.content.ar")
    .then((mod) => {
      Object.assign(DICTS.ar, mod.arContent);
      localeContentLoaded.ar = true;
    })
    .catch(() => {
      // فشل الشبكة: النصوص الأساسيّة العربيّة في هذا الملفّ تبقى فعّالة،
      // والنصوص التحريريّة تعود للإنجليزيّة عبر fallback في t().
    })
    .finally(() => {
      delete localeContentPending[locale];
    });
  localeContentPending[locale] = task;
  return task;
}


// ─── Overrides من /admin/gift-flow ───
// يُحقن وقت تشغيل التطبيق عبر setI18nOverrides({ "gift.title": { ar, en } }).
// أيّ مفتاح هنا يتقدّم على DICTS.
type OverrideEntry = { ar?: string; en?: string; fr?: string };
let RUNTIME_OVERRIDES: Record<string, OverrideEntry> = {};
export function setI18nOverrides(map: Record<string, OverrideEntry>) {
  RUNTIME_OVERRIDES = map || {};
}
/** يدمج خريطة جزئية فوق الموجود (يستعمله loaders متعدّدة بدون أن يدوس أحدهما الآخر). */
export function mergeI18nOverrides(map: Record<string, OverrideEntry>) {
  RUNTIME_OVERRIDES = { ...RUNTIME_OVERRIDES, ...(map || {}) };
}

export function t(locale: Locale, key: string, vars?: Record<string, string>): string {
  const ov = RUNTIME_OVERRIDES[key]?.[locale];
  let s = (ov && ov.trim()) || DICTS[locale][key] || DICTS.en[key] || key;
  if (vars) {
    for (const [k, v] of Object.entries(vars)) {
      s = s.replaceAll(`{${k}}`, v);
    }
  }
  return s;
}

export function detectInitialLocale(): Locale {
  if (typeof navigator === "undefined") return "en";
  const lang = (navigator.language || "en").toLowerCase();
  if (lang.startsWith("ar")) return "ar";
  // الفرنسيّة معطَّلة من الواجهة — متصفّح فرنسيّ يقع على الإنجليزيّة.
  return "en";
}

export function detectInitialCurrency(locale: Locale): Currency {
  if (locale === "ar") return "SAR";
  return "AED";
}

// Format price using the currency Shopify already returned for the active
// market (via @inContext). NO client-side currency conversion — Shopify
// Markets handles per-country pricing & FX server-side.
export function formatMoney(
  amount: string | number,
  currencyCode: string,
  locale: Locale,
): string {
  const amt = Number(amount);
  if (!Number.isFinite(amt)) return "";
  // Literal currency code, Shopify amount, and ISO minor-unit precision.
  try {
    return formatContextMoney({ amount: String(amount), currencyCode }, locale);
  } catch {
    return `${amount} ${currencyCode}`;
  }
}
